"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLogo = exports.StyledContainer = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledContainer = (0, styles_1.styled)(material_1.Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
});
exports.StyledLogo = (0, styles_1.styled)(material_1.Box)({
    display: "block",
    maxHeight: "calc(100vh - 94px)",
    maxWidth: "100vw",
    margin: "0 auto",
});
//# sourceMappingURL=styled.js.map